import React, { useEffect, useState } from 'react'
import { findingSettingEdit } from '../../../../redux/actions/settingActions/findingSettingActions';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import * as $ from 'jquery'
import { useSettingFieldType } from '../helpers/useSettingFieldType';

export default function FindingSetting(props) {
  const { baseName, isVisible } = props
  const [showFindingButton, setShowFindingButton] = useState(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const findingName = useSettingFieldType(baseName)

  useEffect(() => {
    if (history.location.pathname == '/settings/exam-form-template') {
      setShowFindingButton(true)
    }
  }, []);

  const handleFindingModal = (e) => {
    e.preventDefault();
    showFindingSettingModal()
    $('#findingSettingForm-modal').modal('show')
  }

  const showFindingSettingModal = () => {
    dispatch(findingSettingEdit({ test_type: findingName }))
  }

  return (
    <>
      <span className={`mr-3 ${(!showFindingButton || !isVisible) && 'd-none'}`} onClick={(e) => handleFindingModal(e)}>
        <i className="las la-search-plus font-size-18"></i>
      </span>
    </>
  )
}
